
import DialogComponentBuilderDefault from './DialogComponentBuilder';
import BaseComponentBuilderDefault from './BaseComponentBuilder';

export const DialogComponentBuilder = DialogComponentBuilderDefault;
export const BaseComponentBuilder = BaseComponentBuilderDefault;
export * from './provider';
